import aggressive from '@wwe-portal/ui/assets/images/roster/play-style/aggressive.webp';
import chaotic from '@wwe-portal/ui/assets/images/roster/play-style/chaotic.webp';
import defensive from '@wwe-portal/ui/assets/images/roster/play-style/defensive.webp';
import focused from '@wwe-portal/ui/assets/images/roster/play-style/focused.webp';

import RedFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassRed_F.webp';
import RedAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassRed_A.webp';
import RedChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassRed_C.webp';
import RedDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassRed_D.webp';

import YellowFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassYellow_F.webp';
import YellowAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassYellow_A.webp';
import YellowChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassYellow_C.webp';
import YellowDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassYellow_D.webp';

import BlueFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlue_F.webp';
import BlueAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlue_A.webp';
import BlueChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlue_C.webp';
import BlueDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlue_D.webp';

import GreenFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassGreen_F.webp';
import GreenAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassGreen_A.webp';
import GreenChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassGreen_C.webp';
import GreenDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassGreen_D.webp';

import PurpleFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassPurple_F.webp';
import PurpleAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassPurple_A.webp';
import PurpleChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassPurple_C.webp';
import PurpleDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassPurple_D.webp';

import BlackFocused from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlack_F.webp';
import BlackAggressive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlack_A.webp';
import BlackChaotic from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlack_C.webp';
import BlackDefensive from '@wwe-portal/ui/assets/images/roster/play-style/UI_GroupLogo_ClassBlack_D.webp';

export const playStyles = [
  { id: 'Focused', title: 'Focused', iconUrl: focused },
  { id: 'Aggressive', title: 'Aggressive', iconUrl: aggressive },
  { id: 'Defensive', title: 'Defensive', iconUrl: defensive },
  { id: 'Chaotic', title: 'Chaotic', iconUrl: chaotic },
];

export const rosterPlayStyles = [
  { color: 'Color_Red', playStyle: 'Focused', iconUrl: RedFocused },
  { color: 'Color_Red', playStyle: 'Aggressive', iconUrl: RedAggressive },
  { color: 'Color_Red', playStyle: 'Chaotic', iconUrl: RedChaotic },
  { color: 'Color_Red', playStyle: 'Defensive', iconUrl: RedDefensive },

  { color: 'Color_Blue', playStyle: 'Focused', iconUrl: BlueFocused },
  { color: 'Color_Blue', playStyle: 'Aggressive', iconUrl: BlueAggressive },
  { color: 'Color_Blue', playStyle: 'Chaotic', iconUrl: BlueChaotic },
  { color: 'Color_Blue', playStyle: 'Defensive', iconUrl: BlueDefensive },

  { color: 'Color_Green', playStyle: 'Focused', iconUrl: GreenFocused },
  { color: 'Color_Green', playStyle: 'Aggressive', iconUrl: GreenAggressive },
  { color: 'Color_Green', playStyle: 'Chaotic', iconUrl: GreenChaotic },
  { color: 'Color_Green', playStyle: 'Defensive', iconUrl: GreenDefensive },

  { color: 'Color_Purple', playStyle: 'Focused', iconUrl: PurpleFocused },
  { color: 'Color_Purple', playStyle: 'Aggressive', iconUrl: PurpleAggressive },
  { color: 'Color_Purple', playStyle: 'Chaotic', iconUrl: PurpleChaotic },
  { color: 'Color_Purple', playStyle: 'Defensive', iconUrl: PurpleDefensive },

  { color: 'Color_Yellow', playStyle: 'Focused', iconUrl: YellowFocused },
  { color: 'Color_Yellow', playStyle: 'Aggressive', iconUrl: YellowAggressive },
  { color: 'Color_Yellow', playStyle: 'Chaotic', iconUrl: YellowChaotic },
  { color: 'Color_Yellow', playStyle: 'Defensive', iconUrl: YellowDefensive },

  { color: 'Color_Black', playStyle: 'Focused', iconUrl: BlackFocused },
  { color: 'Color_Black', playStyle: 'Aggressive', iconUrl: BlackAggressive },
  { color: 'Color_Black', playStyle: 'Chaotic', iconUrl: BlackChaotic },
  { color: 'Color_Black', playStyle: 'Defensive', iconUrl: BlackDefensive },
];
